export enum TipoinclusaotemporariaEnum {
  MOTIVO_INCLUSAO_LOCAIS_SEM_FILIAIS = 1,
  MOTIVO_INCLUSAO_ESTUDO_MERCADO = 2,
  MOTIVO_INCLUSAO_CONTRAT_SUPERIOR_3_MESES = 3
}
